exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ReferenceUserPopover-cmdType-2YUjC{overflow:hidden;margin:20px 0}.ReferenceUserPopover-cmdType-2YUjC .ReferenceUserPopover-container-2tWde{margin:0;padding:0;list-style-type:none}.ReferenceUserPopover-cmdType-2YUjC .ReferenceUserPopover-container-2tWde>li{display:table-cell;width:1%;text-align:center}.ReferenceUserPopover-cmdType-2YUjC .ReferenceUserPopover-container-2tWde>li button{padding:0;font-size:14px;font-weight:400;text-decoration:none;color:#8a959a}.ReferenceUserPopover-cmdType-2YUjC .ReferenceUserPopover-container-2tWde>li button.active{color:#546d79}.ReferenceUserPopover-cmdType-2YUjC .ReferenceUserPopover-container-2tWde>li span{display:block}.ReferenceUserPopover-cmdType-2YUjC .ReferenceUserPopover-container-2tWde>li span:first-letter{text-transform:uppercase}", ""]);

// exports
exports.locals = {
	"cmdType": "ReferenceUserPopover-cmdType-2YUjC",
	"container": "ReferenceUserPopover-container-2tWde"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/company/components/ReferenceUserPopover.less
// module id = 1628
// module chunks = 0